import React, { createElement, Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import autoprefixer from 'material-ui/utils/autoprefixer';
import CircularProgress from 'material-ui/CircularProgress';
import withWidth from 'material-ui/utils/withWidth';
import compose from 'recompose/compose';
import { userCheck as onUserCheck } from 'admin-on-rest/lib/actions/authActions';

import {
  AdminRoutes,
  AppBar,
  Menu,
  Notification,
  Sidebar,
  defaultTheme,
  setSidebarVisibility as setSidebarVisibilityAction,
} from 'admin-on-rest';

import version from '../config/version';
import { authenticateUser } from '../utils/auth-utils';

const styles = {
  wrapper: {
    // Avoid IE bug with Flexbox, see #467
    display: 'flex',
    flexDirection: 'column',
  },
  main: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  body: {
    backgroundColor: '#edecec',
    display: 'flex',
    flex: 1,
    overflowY: 'hidden',
    overflowX: 'scroll',
  },
  bodySmall: {
    backgroundColor: '#fff',
  },
  content: {
    flex: 1,
    padding: '2em',
  },
  contentSmall: {
    flex: 1,
    paddingTop: '3em',
  },
  loader: {
    position: 'absolute',
    top: 0,
    right: 0,
    margin: 16,
    zIndex: 1200,
  },
  version: {
    position: 'absolute',
    top: 0,
    right: 0,
    zIndex: 9999,
    color: 'whitesmoke',
  },
};

const prefixedStyles = {};

class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
    };
  }

  componentWillMount = async () => {
    this.props.dispatch(this.props.setSidebarVisibility(true));

    try {
      await authenticateUser();
      this.setState({ loading: false });
      if (window.location.hash === '#/login') {
        this.props.dispatch(push('/'));
      }
    } catch (error) {
      this.setState({ loading: false });
      this.props.dispatch(push('/login'));
    }
  };

  render() {
    const { loading } = this.state;
    const { theme } = this.props;

    const muiTheme = getMuiTheme(theme);
    if (loading) {
      return (
        <MuiThemeProvider muiTheme={muiTheme}>
          <div className="login-form">
            <div>
              <CircularProgress id="loading-progress" />
            </div>
          </div>
        </MuiThemeProvider>
      );
    }

    const {
      children,
      customRoutes,
      dashboard,
      isLoading,
      logout,
      menu,
      catchAll,
      title,
      width,
    } = this.props;

    if (!prefixedStyles.main) {
      // do this once because user agent never changes
      const prefix = autoprefixer(muiTheme);
      prefixedStyles.wrapper = prefix(styles.wrapper);
      prefixedStyles.main = prefix(styles.main);
      prefixedStyles.body = prefix(styles.body);
      prefixedStyles.bodySmall = prefix(styles.bodySmall);
      prefixedStyles.content = prefix(styles.content);
      prefixedStyles.contentSmall = prefix(styles.contentSmall);
    }
    const sidebarWidth =
      document.getElementById('sidebar') &&
      document.getElementById('sidebar').offsetWidth;
    return (
      <MuiThemeProvider muiTheme={muiTheme}>
        <div style={prefixedStyles.wrapper}>
          <div style={prefixedStyles.main}>
            <div className="version" style={styles.version}>
              {version}
            </div>
            {width !== 1 && (
              <div className="appbar-container">
                <AppBar title={title} />{' '}
              </div>
            )}
            <div
              className="body"
              style={
                width === 1 ? prefixedStyles.bodySmall : prefixedStyles.body
              }
            >
              <div
                className="content"
                style={{
                  ...(width === 1
                    ? prefixedStyles.contentSmall
                    : prefixedStyles.content),
                  width:
                    width === 1 ? '' : `calc(100% - ${sidebarWidth || 280}px)`,
                  maxWidth:
                    width === 1 ? '' : `calc(100% - ${sidebarWidth || 280}px)`,
                }}
              >
                <AdminRoutes
                  customRoutes={customRoutes}
                  dashboard={dashboard}
                  catchAll={catchAll}
                >
                  {children}
                </AdminRoutes>
              </div>
              <Sidebar theme={theme}>
                {createElement(menu || Menu, {
                  logout,
                  hasDashboard: !!dashboard,
                })}
              </Sidebar>
            </div>
            <Notification />
            {isLoading && (
              <CircularProgress
                className="app-loader"
                color="#fff"
                size={width === 1 ? 20 : 30}
                thickness={2}
                style={styles.loader}
              />
            )}
          </div>
        </div>
      </MuiThemeProvider>
    );
  }
}

const componentPropType = PropTypes.oneOfType([
  PropTypes.func,
  PropTypes.string,
]);

Layout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  catchAll: componentPropType,
  customRoutes: PropTypes.array,
  dashboard: componentPropType,
  isLoading: PropTypes.bool.isRequired,
  logout: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.func,
    PropTypes.string,
  ]),
  menu: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  setSidebarVisibility: PropTypes.func.isRequired,
  title: PropTypes.node.isRequired,
  theme: PropTypes.object,
  width: PropTypes.number,
};

Layout.defaultProps = {
  theme: defaultTheme,
};

function mapStateToProps(state) {
  console.log('state', state);
  return {
    isLoading: state.admin.loading > 0,
  };
}

const enhance = compose(
  connect(mapStateToProps, (dispatch) => ({
    setSidebarVisibility: setSidebarVisibilityAction,
    userCheck: onUserCheck,
    dispatch,
  })),
  withWidth()
);

export default enhance(Layout);
